import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  PapiCustomboxTemplate,
  PapiDaUserProfileTemplatesList,
} from '@wix/da-papi-types';
import {
  BackgroundImageDisplayMode,
  BackgroundType,
  TemplateType,
} from '@wix/da-shared-react/pkg/Background/types';
import { withOffset } from '@wix/da-shared-react/pkg/Stream';
import { OffsetStream } from '@wix/da-shared-react/pkg/Stream/withOffset/types';
import { getStream } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { isApiError, request } from '@wix/da-shared-react/pkg/xhr';
import { fetchMoreCustomboxTemplates } from '../actions/customSectionTemplates';
import { API_BASE_PATH } from '../../constants';
import { streamId } from '../../types/customBoxTemplates';

/**
 * Our fed template type is ingrained into our components to a point that make it difficult to transition cleanly under a feature.
 *
 * So, lets translate them and clean up later.
 *
 * // TODO: Remove this function and use PapiCustomboxTemplate everywhere instead
 */
export function papiTemplateToFedTemplate(
  templateType: PapiCustomboxTemplate
): TemplateType {
  return {
    title: templateType.title,
    subtitle: '',
    previewImage: templateType.previewImage,
    backgroundImage: templateType.backgroundImage ?? '',
    moduleData: {
      backgroundType: templateType.backgroundType as BackgroundType,
      color: templateType.color,
      gradient: templateType.gradient,
      pattern: templateType.pattern,
      imageDisplayMode:
        templateType.imageDisplayMode as BackgroundImageDisplayMode,
      imageTint: templateType.imageTint,
      imageDeviation: templateType.image,
      customtext: templateType.customtext,
    },
  };
}

function* handleFetchMoreTemplates() {
  const stream: OffsetStream = yield select(getStream, streamId);

  const response: PapiDaUserProfileTemplatesList = yield yield call(request, {
    method: 'get',
    url: '/templates/list',
    baseURL: API_BASE_PATH,
    params: {
      offset: stream.nextOffset,
    },
  });

  if (isApiError(response)) {
    yield put(
      withOffset.actions.fetchFailure({
        streamId,
        errorMsg: response.error,
      })
    );
  } else {
    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        items: response.results.map(papiTemplateToFedTemplate),
        hasMore: !!response.hasMore,
        nextOffset: response.nextOffset,
      })
    );
  }
}

export default function* customBoxTemplatesSaga() {
  yield all([
    takeLatest(fetchMoreCustomboxTemplates, handleFetchMoreTemplates),
  ]);
}
